import { FullScreenCarouselDialog } from 'components/VehicleImageCarousel/components/FullScreenCarousel';
import ReactImageGallery from 'react-image-gallery';
import { useDispatch } from 'react-redux';
import {
  closeFullScreen,
  useImages,
  useInitialFullScreenIndex,
  useOpenedFullScreenImageDialog
} from 'services/viewVehicleSlice/viewVehicleSlice';

type Props = {
  imageGalleryRef: React.RefObject<ReactImageGallery>;
};

export const FullScreenImageDialog: React.FC<Props> = ({ imageGalleryRef }) => {
  const fullScreenImageModalOpen = useOpenedFullScreenImageDialog();
  const initialFullScreenIndex = useInitialFullScreenIndex();

  const dispatch = useDispatch();

  const close = () => dispatch(closeFullScreen());

  const images = useImages();

  return (
    <FullScreenCarouselDialog
      relatedRef={imageGalleryRef}
      close={close}
      images={images}
      initialFullScreenIndex={initialFullScreenIndex}
      isOpened={fullScreenImageModalOpen}
    />
  );
};
